import React from 'react';
import * as _ from 'lodash';

import {
  USER_ROLES,
  WORK_GROUPS,
  HOT_WORKCODE,
  WORKER_TYPES,
  SYSTEM_WORK_TIME,
  SYSTEM_WORKER_COUNT,
  WORK_EARLY_OVER_TYPES,
  NUMBER_OF_FIELD_ITEM_TYPE,
  WORK_HOUR_ZONES,
  WORK_DAY_WORKER_STATUS,
} from '../../utilities/constants';

import { WorkDayTime } from '../WorkDayTime';
import { WorkEarlyOverTime } from '../WorkEarlyOverTime';
import ReactDropDownCalender from '../ReactDropDownCalender';

import { FieldTreePartnerCompanyDropdown } from '../dropdowns/single/FieldTreePartnerCompanyDropdown';
import { FieldTreeJobDropdown } from '../dropdowns/single/FieldTreeJob';
import { FieldTreeUserDropdown } from '../dropdowns/single/FieldTreeUser';
import { FieldAItemDropdown } from '../dropdowns/single/FieldAItem';
import { FieldBItemDropdown } from '../dropdowns/single/FieldBItem';
import { FieldCItemDropdown } from '../dropdowns/single/FieldCItem';
import { FieldDItemDropdown } from '../dropdowns/single/FieldDItem';
import { FieldContractorUserDropdown } from '../dropdowns/single/FieldContractorUser';
import { WorkContentsHistoryDropdown } from '../dropdowns/single/WorkContentsHistory';
import { WorkOptionHistoryDropdown } from '../dropdowns/single/WorkOptionHistory';
import { FieldImagesKeyplanDropdown } from '../dropdowns/single/FieldImagesKeyplan';
import { isTargetRoleId } from '../../utilities/roleUtility';
import {
  FormElement,
  FormList,
  FormListItem,
  FormListItemChild,
  FormListItemGroup,
} from '../CommonFormComponents';
import { ArrowDownIcon } from '../icons/ArrowDownIcon';
import { RadioButtonIcon } from '../icons/RadioButtonIcon';
import { FieldTreeSubWorkTypesDropdownHistory } from '../dropdowns/single/FieldTreeSubWorkTypesDropdownHistory';
import { FieldTreeMainWorkTypesDropdownHistory } from '../dropdowns/single/FieldTreeMainWorkTypesDropdownHistory';
import DropdownSelector from '../dropdowns/DropdownSelector';
import SessionStorageService from '../../services/utilities/SessionStorageService';
import { SptService } from '../../services/Spt';

/**
 * 「作業予定一覧 / 作業実績一覧」共通
 *  新規作成 / 編集 共通
 */
export const WorkScheduleForm = ({
  companyItemSettings,
  companyItemOrders,
  roleId,
  isEdit,
  values,
  errors,
  workTime,
  image,
  imageJson,
  aborted,
  approved = false,
  partnerCompanyApprovalFlag,
  usePartnerCompanyApprovalFlag,
  partnerApprovalName,
  isFirstLoaded,
  fieldItem,
  pulldownName,
  events,
  isWorkHourModal = false,
  isCopy = false,
  keyplanObserver,
  options,
  loaded,
  setLoadedKeyPlanData,
  setValueMainWorkTypes,
  setValueSubWorkTypes,
  clearSelect,
  isShowMainSubDropdown,
  isShowSptDropdown,
  setWorkDateFrom,
  setWorkDateTo,
  setWorkDate,
  keySubWork,
  onLoadDataMain,
  onLoadDataSub,
  keyMainWork,
  listHistoriesMain,
  listHistoriesSub,
  setListHistoriesMainWork,
  setListHistoriesSubWork,
  isFirstTimeGetHistories,
  setFirstTimeGetHistories,
  removeRequireSubAndWorkPlace,
  isWorkSchedule,
  reflectWorkTotal,
  workDayWorkersStatus,
  getWorkDayWorkerDescription,
  checkInReflectToResultFlag,
}) => {
  const isAbortedOrApproved = aborted || approved || partnerCompanyApprovalFlag;
  const isDisplayReflectComponent =
    checkInReflectToResultFlag &&
    !isWorkSchedule &&
    isEdit &&
    values.work_hour_zone.toString() === WORK_HOUR_ZONES.day.key;
  const workDayWorkerRightComponent =
    isDisplayReflectComponent && _.isFunction(getWorkDayWorkerDescription)
      ? getWorkDayWorkerDescription()
      : null;

  const renderForm = (orders, settings) => {
    // company_item_orders + company_item_settingsを取得して、マージして、フォームを表示する
    const merged = [
      ...orders
        .concat(settings)
        .reduce(
          (m, o) =>
            m.set(o.item_name, Object.assign(m.get(o.item_name) || {}, o)),
          new Map()
        )
        .values(),
    ];

    const mergedSorted = _.sortBy(merged, ['item_order_number']);
    return orders
      ? mergedSorted.map((child, i) => {
          let key;
          key = `${child.item_name}-${i}`;
          switch (child.item_name) {
            case 'work_date': // 期間
              return (
                <FormListItem
                  label={child.item_display_name}
                  key={key}
                  required={true}
                >
                  {isEdit ? (
                    <FormElement validate={errors.work_date_from}>
                      <div className='input-date-range'>
                        <ReactDropDownCalender
                          disabled={isAbortedOrApproved}
                          onChange={date => {
                            events.form.calender('work_date', date);
                            setWorkDate(date);
                          }}
                          value={values.work_date}
                        />
                      </div>
                    </FormElement>
                  ) : (
                    <FormElement validate={errors.work_date_from}>
                      <div className='input-date-range'>
                        <ReactDropDownCalender
                          name='work_date_from'
                          onChange={date => {
                            events.form.calender('work_date_from', date);
                            setWorkDateFrom(date);
                          }}
                          validate={events.form.validate}
                          value={values.work_date_from}
                        />
                        <span className='input-date-range__bar'>〜</span>
                        <ReactDropDownCalender
                          name='work_date_to'
                          onChange={date => {
                            events.form.calender('work_date_to', date);
                            setWorkDateTo(date);
                          }}
                          validate={events.form.validate}
                          value={values.work_date_to}
                        />
                      </div>
                    </FormElement>
                  )}
                </FormListItem>
              );
            case 'partner_company_id': // 協力会社
              return (
                <FormListItem
                  label={child.item_display_name}
                  required={true}
                  key={key}
                >
                  <FieldTreePartnerCompanyDropdown
                    value={values.field_tree_id}
                    name={
                      _.has(pulldownName, 'company_name')
                        ? pulldownName.company_name
                        : null
                    }
                    error={errors.field_tree_id}
                    readOnly={isAbortedOrApproved}
                    set={events.form.dropdown}
                    validate={events.form.validate}
                    isEdit={isEdit}
                    dateTo={isEdit ? values.work_date : values.work_date_to}
                    isFormListDefault={true}
                    workForm={true}
                  />
                </FormListItem>
              );
            case 'job_id': // 職種
              return (
                <FormListItem
                  label={child.item_display_name}
                  required={true}
                  key={key}
                >
                  <FieldTreeJobDropdown
                    value={values.job_id}
                    name={
                      _.has(pulldownName, 'job_name')
                        ? pulldownName.job_name
                        : null
                    }
                    error={errors.job_id}
                    fieldTreeId={values.field_tree_id}
                    readOnly={isAbortedOrApproved}
                    set={events.form.dropdown}
                    validate={events.form.validate}
                    isCopy={isCopy}
                    userValueChangeFlag={values.userValueChangeFlag}
                    dateTo={isEdit ? values.work_date : values.work_date_to}
                    isFormListDefault={true}
                  />
                </FormListItem>
              );
            case 'foreman_user_id': // 職長
              return (
                <React.Fragment key={key}>
                  <FormListItem label={child.item_display_name} required={true}>
                    <FieldTreeUserDropdown
                      value={values.foreman_user_id}
                      name={
                        _.has(pulldownName, 'foreman_user_name')
                          ? pulldownName.foreman_user_name
                          : null
                      }
                      error={errors.foreman_user_id}
                      fieldTreeId={values.field_tree_id}
                      jobId={values.job_id}
                      readOnly={isAbortedOrApproved}
                      set={events.form.dropdown}
                      validate={events.form.validate}
                      isCopy={isCopy}
                      userValueChangeFlag={values.userValueChangeFlag}
                      dateTo={isEdit ? values.work_date : values.work_date_to}
                      isFormListDefault={true}
                      isEdit={isEdit}
                      setFirstTimeGetHistories={setFirstTimeGetHistories}
                    />
                  </FormListItem>
                  {isShowMainSubDropdown && (
                    <React.Fragment>
                      <FormListItem
                        label='工種1（大工種）'
                        required={isShowMainSubDropdown}
                      >
                        <FieldTreeMainWorkTypesDropdownHistory
                          error={errors.main_work_type_id}
                          value={values.main_work_type_id}
                          name={
                            isAbortedOrApproved &&
                            _.get(values, 'duplicate_name_flag')
                              ? `${values.main_work_type_name}（${values.template_name}）`
                              : values.main_work_type_name
                          }
                          setValueMainWorkTypes={setValueMainWorkTypes}
                          validate={events.form.validate}
                          set={events.form.dropdown}
                          readOnly={isAbortedOrApproved}
                          isEdit={isEdit}
                          column={'main_work_type_id'}
                          clearSelect={clearSelect}
                          foremanUserId={values.foreman_user_id}
                          isFormListDefault={true}
                          onLoadDataMain={onLoadDataMain}
                          keyMainWork={keyMainWork}
                          resetKeys={values.foreman_user_id}
                          listHistoriesMain={listHistoriesMain}
                          setListHistoriesMainWork={setListHistoriesMainWork}
                          isFirstTimeGetHistories={isFirstTimeGetHistories}
                          setFirstTimeGetHistories={setFirstTimeGetHistories}
                          removeRequireSubAndWorkPlace={
                            removeRequireSubAndWorkPlace
                          }
                          isCopy={isCopy}
                        />
                      </FormListItem>
                      <FormListItem
                        label='工種2（小工種）'
                        required={values.isSubTypeRequired}
                      >
                        <FieldTreeSubWorkTypesDropdownHistory
                          error={errors.sub_work_type_id}
                          value={values.sub_work_type_id}
                          name={values.sub_work_type_name}
                          mainWorkTypeId={values.main_work_type_id}
                          setValueSubWorkTypes={setValueSubWorkTypes}
                          disabledDropdown={values.isSubTypeRequired}
                          readOnly={isAbortedOrApproved}
                          isEdit={isEdit}
                          validate={events.form.validate}
                          set={events.form.dropdown}
                          column={'sub_work_type_id'}
                          keySubWork={keySubWork}
                          foremanUserId={values.foreman_user_id}
                          isFormListDefault={true}
                          onLoadDataSub={onLoadDataSub}
                          resetKeys={[values.main_work_type_id, keyMainWork]}
                          listHistoriesSub={listHistoriesSub}
                          setListHistoriesSubWork={setListHistoriesSubWork}
                          isFirstTimeGetHistories={isFirstTimeGetHistories}
                          isCopy={isCopy}
                        />
                      </FormListItem>
                    </React.Fragment>
                  )}
                  {/*GENBATON工種*/}
                  {isShowSptDropdown && (
                    <FormListItem label='GENBATON工種'>
                      <FormElement>
                        {isAbortedOrApproved ? (
                          pulldownName.spt_main_sub_progress_quanlity_name
                        ) : (
                          <DropdownSelector
                            label='工種を選択'
                            selectorName='spt_field_work_type_id'
                            api={params =>
                              SptService.getListSptFieldWorkTypes(
                                SessionStorageService.getFieldId(),
                                params
                              )
                            }
                            apiSearchKey='name'
                            selectedValues={
                              values.spt_field_work_type_id
                                ? [values.spt_field_work_type_id]
                                : []
                            }
                            selectedName={
                              pulldownName.spt_main_sub_progress_quanlity_name
                            }
                            keyName='spt_main_sub_progress_quanlity_name'
                            apiBindDataKey='spt_field_work_types'
                            onSelect={events.form.dropdown}
                            isOptional={true}
                            dropdownSelectStyle={{ width: '238px' }}
                          />
                        )}
                      </FormElement>
                    </FormListItem>
                  )}
                </React.Fragment>
              );
            case 'abcd_item_id':
              return (
                <div key={key}>
                  {/* 棟 */}
                  {!!fieldItem.field_item_list1_display_flag && (
                    <FormListItem
                      label={fieldItem.field_item_list1_title}
                      required={_.includes(
                        values.workPlaceRequireType,
                        NUMBER_OF_FIELD_ITEM_TYPE.itemA
                      )}
                    >
                      <FieldAItemDropdown
                        value={values.a_item_id}
                        name={
                          _.has(pulldownName, 'a_item_name')
                            ? pulldownName.a_item_name
                            : null
                        }
                        error={errors.a_item_id}
                        readOnly={isAbortedOrApproved}
                        set={events.form.dropdown}
                        validate={events.form.validate}
                        title={fieldItem.field_item_list1_title}
                        options={options.field_item_a_lists || []}
                        loaded={loaded}
                        isFormListDefault={true}
                        isOptional={
                          !_.includes(
                            values.workPlaceRequireType,
                            NUMBER_OF_FIELD_ITEM_TYPE.itemA
                          )
                        }
                      />
                    </FormListItem>
                  )}
                  {/* 階 */}
                  {!!fieldItem.field_item_list2_display_flag && (
                    <FormListItem
                      label={fieldItem.field_item_list2_title}
                      required={_.includes(
                        values.workPlaceRequireType,
                        NUMBER_OF_FIELD_ITEM_TYPE.itemB
                      )}
                    >
                      <FieldBItemDropdown
                        value={values.b_item_id}
                        name={
                          _.has(pulldownName, 'b_item_name')
                            ? pulldownName.b_item_name
                            : null
                        }
                        error={errors.b_item_id}
                        readOnly={isAbortedOrApproved}
                        set={events.form.dropdown}
                        validate={events.form.validate}
                        title={fieldItem.field_item_list2_title}
                        options={options.field_item_b_lists || []}
                        loaded={loaded}
                        isFormListDefault={true}
                        isOptional={
                          !_.includes(
                            values.workPlaceRequireType,
                            NUMBER_OF_FIELD_ITEM_TYPE.itemB
                          )
                        }
                      />
                    </FormListItem>
                  )}
                  {/* エリア */}
                  {!!fieldItem.field_item_list3_display_flag && (
                    <FormListItem
                      label={fieldItem.field_item_list3_title}
                      required={_.includes(
                        values.workPlaceRequireType,
                        NUMBER_OF_FIELD_ITEM_TYPE.itemC
                      )}
                    >
                      <FieldCItemDropdown
                        value={values.c_item_id}
                        name={
                          _.has(pulldownName, 'c_item_name')
                            ? pulldownName.c_item_name
                            : null
                        }
                        validate={events.form.validate}
                        error={errors.c_item_id}
                        readOnly={isAbortedOrApproved}
                        set={events.form.dropdown}
                        title={fieldItem.field_item_list3_title}
                        options={options.field_item_c_lists || []}
                        loaded={loaded}
                        isFormListDefault={true}
                        isOptional={
                          !_.includes(
                            values.workPlaceRequireType,
                            NUMBER_OF_FIELD_ITEM_TYPE.itemC
                          )
                        }
                      />
                    </FormListItem>
                  )}
                  {/* 工区 */}
                  {!!fieldItem.field_item_list4_display_flag && (
                    <FormListItem
                      label={fieldItem.field_item_list4_title}
                      required={_.includes(
                        values.workPlaceRequireType,
                        NUMBER_OF_FIELD_ITEM_TYPE.itemD
                      )}
                    >
                      <FieldDItemDropdown
                        value={values.d_item_id}
                        name={
                          _.has(pulldownName, 'd_item_name')
                            ? pulldownName.d_item_name
                            : null
                        }
                        validate={events.form.validate}
                        error={errors.d_item_id}
                        readOnly={isAbortedOrApproved}
                        set={events.form.dropdown}
                        title={fieldItem.field_item_list4_title}
                        options={options.field_item_d_lists || []}
                        loaded={loaded}
                        isFormListDefault={true}
                        isOptional={
                          !_.includes(
                            values.workPlaceRequireType,
                            NUMBER_OF_FIELD_ITEM_TYPE.itemD
                          )
                        }
                      />
                    </FormListItem>
                  )}
                </div>
              );
            case 'contents':
              return (
                <FormListItem
                  label={child.item_display_name}
                  required={true}
                  key={key}
                >
                  <WorkContentsHistoryDropdown
                    value={values.contents}
                    error={errors.contents}
                    fieldTreeId={values.field_tree_id}
                    jobId={values.job_id}
                    foremanUserId={values.foreman_user_id}
                    readOnly={isAbortedOrApproved}
                    set={events.form.dropdown}
                    validate={events.form.validate}
                    isFormListDefault={true}
                  />
                </FormListItem>
              );
            case 'item_1':
              return item(1);
            case 'item_2':
              return item(2);
            case 'item_3':
              return item(3);
            case 'item_4': // 予備1
              return item(4);
            case 'item_5': // 予備2
              return item(5);
            case 'item_6': // 予備3
              return item(6);
            case 'item_7': // 予備4
              return item(7);
            case 'item_8': // 予備5
              return item(8);
            case 'item_9': // 予備6
              return item(9);
            case 'item_10': // 予備7
              return item(10);
            case 'item_11': // 予備8
              return item(11);
            case 'item_12': // 予備9
              return item(12);
            case 'item_13': // 予備10
              return item(13);
            case 'item_14': // 予備11
              return item(14);
            case 'item_15': // 予備12
              return item(15);
            case 'item_16': // 予備13
              return item(16);
            case 'item_17': // 予備14
              return item(17);
            case 'item_18': // 予備15
              return item(18);
            case 'item_19': // 予備16
              return item(19);
            case 'item_20': // 予備17
              return item(20);
            case 'work_day_worker':
              return (
                <FormListItemGroup
                  label={child.item_display_name}
                  key={key}
                  rightComponent={workDayWorkerRightComponent}
                >
                  <DayworkerForm
                    isAbortedOrApproved={isAbortedOrApproved}
                    displayFiFteenMinuteFlg={values.display_fifteen_minute_flg}
                    set15Time={events.form.set15Time}
                    dayworkerType={values.dayworker_type}
                    setForm={events.form.set}
                    workDayworkers={values.work_dayworkers}
                    workTime={workTime}
                    validate={events.form.validate}
                    errors={errors}
                    woman={values.woman}
                    nonJapanese={values.non_japanese}
                    workEarlyTimes={values.work_early_times}
                    workDayTimeCallback={events.form.workDayTime}
                    earlyOverTimeCallback={events.form.earlyOverTime}
                    workOverTimes={values.work_over_times}
                    workDayWorkersStatus={workDayWorkersStatus}
                    reflectWorkTotal={reflectWorkTotal}
                    isDisplayReflectComponent={isDisplayReflectComponent}
                  />
                </FormListItemGroup>
              );
            case 'memo': // 指示書備考欄
              return (
                <FormListItem label={child.item_display_name} key={key}>
                  <FormElement validate={errors.memo}>
                    <input
                      type='text'
                      name='memo'
                      disabled={isAbortedOrApproved}
                      maxLength={31}
                      value={values.memo}
                      onChange={e => events.form.set(e)}
                    />
                  </FormElement>
                </FormListItem>
              );
            case 'hot_work': // 火気
              return (
                <FormListItemGroup label={child.item_display_name} key={key}>
                  <FormListItemChild label='種別'>
                    <FormElement>
                      <div className='form-container form-container--extra'>
                        <div className='form-container__item'>
                          {isAbortedOrApproved && !values.hot_work_code ? (
                            ''
                          ) : (
                            <React.Fragment>
                              <select
                                name='hot_work_code'
                                value={_.defaultTo(values.hot_work_code, '')}
                                onChange={e => events.form.set(e)}
                                disabled={isAbortedOrApproved}
                              >
                                <option value=''>---</option>
                                {_.map(HOT_WORKCODE, workCode => (
                                  <option key={workCode.id} value={workCode.id}>
                                    {workCode.name}
                                  </option>
                                ))}
                              </select>
                              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                            </React.Fragment>
                          )}
                        </div>
                      </div>
                    </FormElement>
                  </FormListItemChild>
                  <FormListItemChild label='使用時間'>
                    <FormElement>
                      <div className='form-container form-container--extra'>
                        <div className='form-container__item'>
                          <div className='input-date-range'>
                            {isAbortedOrApproved && !values.hot_work_start ? (
                              ''
                            ) : (
                              <React.Fragment>
                                <select
                                  name='hot_work_start'
                                  value={_.defaultTo(values.hot_work_start, '')}
                                  onChange={e => events.form.set(e)}
                                  disabled={isAbortedOrApproved}
                                >
                                  <option value=''>---</option>
                                  {_.map(SYSTEM_WORK_TIME, workTime => (
                                    <option
                                      key={workTime.id}
                                      value={workTime.normal}
                                    >
                                      {workTime.name}
                                    </option>
                                  ))}
                                </select>
                                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                              </React.Fragment>
                            )}
                            {(!isAbortedOrApproved ||
                              values.hot_work_start ||
                              values.hot_work_end) && (
                              <span className='input-date-range__bar'>〜</span>
                            )}
                            {isAbortedOrApproved && !values.hot_work_end ? (
                              ''
                            ) : (
                              <React.Fragment>
                                <select
                                  name='hot_work_end'
                                  value={_.defaultTo(values.hot_work_end, '')}
                                  onChange={e => events.form.set(e)}
                                  disabled={isAbortedOrApproved}
                                >
                                  <option value=''>---</option>
                                  {_.map(SYSTEM_WORK_TIME, workTime => (
                                    <option
                                      key={workTime.id}
                                      value={workTime.normal}
                                    >
                                      {workTime.name}
                                    </option>
                                  ))}
                                </select>
                                <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    </FormElement>
                  </FormListItemChild>
                </FormListItemGroup>
              );
            case 'oxygen_lack': // 酸欠
              return (
                fieldItem.oxygen_lack_print_flag === 1 && (
                  <FormListItemGroup label={child.item_display_name} key={key}>
                    <FormListItemChild label='酸素欠乏危険作業主任者'>
                      <FormElement>
                        <div className='form-container form-list__oxygen form-container--extra'>
                          <div className='form-container__item'>
                            <span className='form-container__item-sub-label'>
                              1行目
                            </span>
                            <input
                              type='text'
                              disabled={isAbortedOrApproved}
                              name='oxygen_lack_dangerous_work_upper'
                              value={values.oxygen_lack_dangerous_work_upper}
                              maxLength={62}
                              onChange={e => events.form.set(e)}
                            />
                          </div>
                          <div className='form-container__item'>
                            <span className='form-container__item-sub-label form-container__item-sub-label--space'>
                              2行目
                            </span>
                            <input
                              type='text'
                              disabled={isAbortedOrApproved}
                              name='oxygen_lack_dangerous_work_lower'
                              value={values.oxygen_lack_dangerous_work_lower}
                              maxLength={62}
                              onChange={e => events.form.set(e)}
                            />
                          </div>
                        </div>
                      </FormElement>
                    </FormListItemChild>
                    <FormListItemChild label='特別教育修了者'>
                      <FormElement>
                        <div className='form-container form-list__oxygen form-container--extra'>
                          <div className='form-container__item'>
                            <span className='form-container__item-sub-label'>
                              1行目
                            </span>
                            <input
                              type='text'
                              disabled={isAbortedOrApproved}
                              name='oxygen_lack_education_complete_upper'
                              maxLength={62}
                              value={
                                values.oxygen_lack_education_complete_upper
                              }
                              onChange={e => events.form.set(e)}
                            />
                          </div>
                          <div className='form-container__item'>
                            <span className='form-container__item-sub-label form-container__item-sub-label--space'>
                              2行目
                            </span>
                            <input
                              type='text'
                              disabled={isAbortedOrApproved}
                              name='oxygen_lack_education_complete_lower'
                              maxLength={62}
                              value={
                                values.oxygen_lack_education_complete_lower
                              }
                              onChange={e => events.form.set(e)}
                            />
                          </div>
                        </div>
                      </FormElement>
                    </FormListItemChild>
                  </FormListItemGroup>
                )
              );
            case 'manager_user_id': // 元請担当者
              return (
                <FormListItem label={child.item_display_name} key={key}>
                  <FieldContractorUserDropdown
                    value={values.manager_user_id}
                    name={
                      _.has(pulldownName, 'manager_user_name')
                        ? pulldownName.manager_user_name
                        : null
                    }
                    fieldTreeId={values.field_tree_id}
                    jobId={values.job_id}
                    readOnly={isAbortedOrApproved}
                    set={events.form.dropdown}
                    isFormListDefault={true}
                    dateToValue={
                      isEdit ? values.work_date : values.work_date_to
                    }
                    isFilterByDateTo={true}
                  />
                </FormListItem>
              );
            case 'key_plan_category_code': // 作業安全指示書用画像 （キープラン）欄
              return (
                <FormListItem label={child.item_display_name} key={key}>
                  <FieldImagesKeyplanDropdown
                    imageUrl={image}
                    imageJson={imageJson}
                    keyplanCode={
                      values.work_key_plan_image.key_plan_category_code
                    }
                    setEditFlag={events.form.setEditKeyplanFlag}
                    readOnly={isAbortedOrApproved}
                    set={events.form.keyplan}
                    isEdit={isEdit}
                    deleteKeyPlan={() => events.form.deleteKeyPlan()}
                    keyplanObserver={() => keyplanObserver()}
                    setLoadedKeyPlanData={setLoadedKeyPlanData}
                    isOptional={true}
                    isFormListDefault={true}
                  />
                </FormListItem>
              );
            case 'groups': // 印刷グループ
              return (
                <FormListItem label={child.item_display_name} key={key}>
                  <FormElement>
                    <select
                      name='groups'
                      value={values.groups}
                      onChange={e => events.form.set(e)}
                      disabled={isAbortedOrApproved}
                      className='form-list__select--short'
                    >
                      {_.map(WORK_GROUPS, workGroup => (
                        <option key={workGroup} value={workGroup}>
                          {workGroup}
                        </option>
                      ))}
                    </select>
                    <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
                  </FormElement>
                </FormListItem>
              );
            default:
              console.error(
                `company_item_orders または company_item_settings の item_name が${
                  child.item_name
                }です。正しい値を入れてください。`
              );
              return; // Error, 何も表示しない
          }
        })
      : null;
  };
  //予備1~20
  const item = item => {
    // 設定項目カウントよりitemが大きい場合はレンダリングしない
    // 項目1-3は固定
    if (item - 3 > fieldItem.create_item_count) {
      return null;
    }
    const workOptionItemId = item;
    return (
      fieldItem[`option${item}_display_flag`] === 1 && (
        <FormListItem
          label={fieldItem[`option${item}_title`]}
          required={fieldItem[`option${item}_must_flag`] === 1}
          key={`option${item}`}
        >
          {fieldItem[`option${item}_history_flag`] ? (
            <WorkOptionHistoryDropdown
              value={values[`option${workOptionItemId}`]}
              fieldTreeId={values.field_tree_id}
              jobId={values.job_id}
              error={errors[`option${workOptionItemId}`]}
              foremanUserId={values.foreman_user_id}
              resetKeys={[
                values.field_tree_id,
                values.job_id,
                values.foreman_user_id,
              ]}
              column={`option${workOptionItemId}`}
              readOnly={isAbortedOrApproved}
              set={events.form.dropdown}
              validate={events.form.validate}
              maxLength={item <= 3 ? 255 : 31}
            />
          ) : (
            <FormElement validate={errors[`option${workOptionItemId}`]}>
              <input
                type='text'
                disabled={isAbortedOrApproved}
                maxLength={item <= 3 ? 255 : 31}
                onChange={e =>
                  events.form.dropdown(
                    `option${workOptionItemId}`,
                    e.target.value
                  )
                }
                onBlur={() => events.form.validate(`option${workOptionItemId}`)}
                value={values[`option${workOptionItemId}`]}
              />
            </FormElement>
          )}
        </FormListItem>
      )
    );
  };
  // 人工編集モーダルの場合はcompany_item_ordersなどを無視して人工フォームを表示する
  if (isWorkHourModal) {
    return (
      <FormList>
        <DayworkerForm
          isAbortedOrApproved={isAbortedOrApproved}
          displayFiFteenMinuteFlg={values.display_fifteen_minute_flg}
          set15Time={events.form.set15Time}
          dayworkerType={values.dayworker_type}
          setForm={events.form.set}
          workDayworkers={values.work_dayworkers}
          workTime={workTime}
          validate={events.form.validate}
          errors={errors}
          woman={values.woman}
          nonJapanese={values.non_japanese}
          workEarlyTimes={values.work_early_times}
          workDayTimeCallback={events.form.workDayTime}
          earlyOverTimeCallback={events.form.earlyOverTime}
          workOverTimes={values.work_over_times}
          isWorkHourModal={true}
          workDayWorkersStatus={workDayWorkersStatus}
          reflectWorkTotal={reflectWorkTotal}
          isDisplayReflectComponent={isDisplayReflectComponent}
        />
      </FormList>
    );
  }
  return (
    <div className='slide-view__body WorkResultEdit'>
      <div className='main__table set-width-dropdown'>
        <FormList isSpace={true}>
          {isEdit === false &&
            isTargetRoleId(
              [USER_ROLES.partner, USER_ROLES.foreman],
              roleId
            ) && (
              <FormListItem>
                <span
                  id='open-modal-confirm-copy'
                  className='btn-text form-list__copy-btn'
                  onClick={() => events.dialog.showCopy()}
                >
                  前回登録した内容をコピー
                </span>
              </FormListItem>
            )}
          {loaded === false
            ? null
            : renderForm(companyItemOrders, companyItemSettings)}
          {usePartnerCompanyApprovalFlag && isFirstLoaded && (
            <React.Fragment>
              <FormListItem label={`協力会社${partnerApprovalName}`}>
                <FormElement>
                  <input
                    type='text'
                    disabled
                    value={
                      partnerCompanyApprovalFlag
                        ? `ステータス：${partnerApprovalName}済`
                        : `ステータス：未${partnerApprovalName}`
                    }
                  />
                  <input
                    type='text'
                    disabled
                    style={{ width: '300px' }}
                    value={`更新者：${
                      values.partner_company_approval_updated_user_name
                    }`}
                  />
                  <input
                    type='text'
                    disabled
                    style={{ width: '300px' }}
                    value={`更新日時：${
                      values.partner_company_approval_updated_at
                    }`}
                  />
                </FormElement>
              </FormListItem>
            </React.Fragment>
          )}
        </FormList>
      </div>
    </div>
  );
};

export const DayworkerForm = ({
  isAbortedOrApproved,
  displayFiFteenMinuteFlg,
  set15Time,
  dayworkerType,
  setForm,
  workDayworkers,
  workTime,
  validate,
  errors,
  woman,
  nonJapanese,
  workEarlyTimes,
  workOverTimes,
  workDayTimeCallback,
  earlyOverTimeCallback,
  isWorkHourModal = false,
  reflectWorkTotal,
  workDayWorkersStatus,
  isDisplayReflectComponent,
}) => {
  const is15TimeChecked = displayFiFteenMinuteFlg ? 'checked' : '';
  const selectedWorker = Object.values(WORKER_TYPES).find(
    item => item.id === dayworkerType
  );
  const selectedWorkerName = selectedWorker ? selectedWorker.name : '';

  return (
    <React.Fragment>
      <FormListItemChild
        label='契約'
        required={true}
        isFormListItem={isWorkHourModal}
      >
        <FormElement>
          <div className='form-container'>
            <div className='form-container__item'>
              <div className='form-list-radio'>
                {!isAbortedOrApproved
                  ? _.map(WORKER_TYPES, workerType => (
                      <div
                        className='form-list-radio__item'
                        key={workerType.id}
                      >
                        <label className='radio'>
                          <input
                            type='radio'
                            name='dayworker_type'
                            value={workerType.id}
                            checked={
                              (!dayworkerType &&
                                workerType.id === WORKER_TYPES.contractor.id) ||
                              workerType.id === parseInt(dayworkerType)
                            }
                            onChange={e => {
                              setForm(e);
                            }}
                          />
                          <RadioButtonIcon className='icon--2x' />
                          <span>{workerType.name}</span>
                        </label>
                      </div>
                    ))
                  : selectedWorkerName}
              </div>
            </div>
          </div>
        </FormElement>
      </FormListItemChild>
      <FormListItemChild
        label='人工'
        required={true}
        isSpace={true}
        isFormListItem={isWorkHourModal && true}
      >
        <FormElement validate={errors.workers}>
          <div className='form-container work-day-workers-container'>
            <div
              className={`form-container__item ${
                isWorkHourModal ? 'form-container__item--no-space' : ''
              } ${
                isAbortedOrApproved ? 'work-day-workers__15time--hidden' : ''
              }`}
            >
              <label className='checkbox'>
                <input
                  type='checkbox'
                  disabled={isAbortedOrApproved}
                  checked={is15TimeChecked}
                  readOnly={true}
                  onClick={e => !isAbortedOrApproved && set15Time(e)}
                />
                <i className='i-square i-3x' aria-hidden='true' />
                <span className='toggle-radius__multiline'>
                  人工を15分単位で計算する
                </span>
              </label>
            </div>
            {isDisplayReflectComponent && (
              <div className='reflect-work-total'>
                入場人数：{reflectWorkTotal}人
              </div>
            )}
            <WorkDayTime
              workDayworkers={workDayworkers}
              workTime={workTime}
              isFifteen={displayFiFteenMinuteFlg}
              callbacks={workDayTimeCallback}
              validate={validate}
              readOnly={isAbortedOrApproved}
              isWorkHourModal={isWorkHourModal}
              status={
                isDisplayReflectComponent
                  ? workDayWorkersStatus
                  : WORK_DAY_WORKER_STATUS.initial
              }
            />
          </div>
        </FormElement>
      </FormListItemChild>
      <FormListItemChild
        label='女性・外国人数'
        isSpace={true}
        isFormListItem={isWorkHourModal && true}
      >
        <FormElement
          validate={
            (_.isUndefined(errors.woman) ? '' : errors.woman) +
            (_.isUndefined(errors.non_japanese) ? '' : errors.non_japanese)
          }
        >
          <div className='form-container'>
            <div
              className={`form-container__item ${
                isWorkHourModal ? 'form-container__item--no-space' : ''
              }`}
            >
              <span className='form-container__item-sub-label'>女性</span>
              <select
                name='woman'
                className='form-list__select--man-hours'
                value={woman}
                onChange={e => {
                  setForm(e);
                  setTimeout(name => validate(name), 100, e.target.name);
                }}
                onBlur={e => validate(e.target.name)}
                disabled={isAbortedOrApproved}
              >
                {_.map(SYSTEM_WORKER_COUNT, worker => (
                  <option key={worker.id} value={worker.id}>
                    {worker.name} 人
                  </option>
                ))}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
              <span className='form-container__item-sub-label form-container__item-sub-label--space'>
                外国人
              </span>
              <select
                name='non_japanese'
                className='form-list__select--man-hours'
                value={nonJapanese}
                onChange={e => {
                  setForm(e);
                  setTimeout(name => validate(name), 100, e.target.name);
                }}
                onBlur={e => validate(e.target.name)}
                disabled={isAbortedOrApproved}
              >
                {_.map(SYSTEM_WORKER_COUNT, worker => (
                  <option key={worker.id} value={worker.id}>
                    {worker.name} 人
                  </option>
                ))}
              </select>
              <ArrowDownIcon className='icon--2_4x form-list__arrow-icon' />
            </div>
          </div>
        </FormElement>
      </FormListItemChild>
      <FormListItemChild
        label='早出'
        isSpace={true}
        isFormListItem={isWorkHourModal && true}
      >
        <FormElement>
          <div className='form-container'>
            <WorkEarlyOverTime
              workEarlyOverTimes={workEarlyTimes}
              name='work_early_times'
              flag={WORK_EARLY_OVER_TYPES.early.id}
              callbacks={earlyOverTimeCallback}
              readOnly={isAbortedOrApproved}
              isWorkHourModal={isWorkHourModal}
            />
          </div>
        </FormElement>
      </FormListItemChild>
      <FormListItemChild
        label='残業'
        isSpace={true}
        isFormListItem={isWorkHourModal && true}
      >
        <FormElement>
          <div className='form-container'>
            <WorkEarlyOverTime
              workEarlyOverTimes={workOverTimes}
              name='work_over_times'
              flag={WORK_EARLY_OVER_TYPES.over.id}
              callbacks={earlyOverTimeCallback}
              readOnly={isAbortedOrApproved}
              isWorkHourModal={isWorkHourModal}
            />
          </div>
        </FormElement>
      </FormListItemChild>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/WorkSchedule.jsx